import { surveyInstance } from '..';

const archiveSurvey = async (id) => {
  await surveyInstance.post(`/survey/${id}/archive`);
};

export default archiveSurvey;
